import { render, staticRenderFns } from "./RecommendTables.vue?vue&type=template&id=28aba911"
import script from "./RecommendTables.vue?vue&type=script&lang=js"
export * from "./RecommendTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports